import Proxy from '../Proxy';

class OrderPricingItemProxy extends Proxy {
  /**
   * The constructor for the EstimationComplexProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('region-order-price-items', parameters);
  }
}

export default OrderPricingItemProxy;
